import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  arrowIconStyles: { marginLeft: scale(4), paddingRight: scale(10.5) },
  buttonStyle: { height: scale(32) },
  textStyle: { paddingLeft: scale(10.5) },
});
export default styles;
